const messages = {
    buttons: {
        productBrochures: "Scopri",
    },
    index: {
        title: "INFORMAZIONI SUL PRODOTTO",
        description: "Scarica qui gli ultimi opuscoli e volantini dei nostri pneumatici Bridgestone e Firestone.",
        categories: {
            productBrochures: {
                title: "Opuscoli prodotti",
                description: "Opuscoli delle gamme di pneumatici Bridgestone e Firestone",
            },
            bDrive: {
              title: "Immagini dei prodotti",
              description: "Nel nostro portale B-DRIVE puoi scaricare le immagini aggiornate.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

